import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'copies_terms_conditions_documents_are_not_provided_workers'

export const dataPointDefinition = {
  retracedId: 'copies_terms_conditions_documents_are_not_provided_workers',
  name: 'Copies of terms and conditions documents are not provided to workers',
  description:
    'The intent of this option selection is to understand if copies of terms and conditions documents are physically given to workers to keep for themselves. ',
  meta: {
    slcpMeta: {
      key: 'rh-emp-23x',
      number: 'RH-EMP-14-4',
      dataType: 'boolean',
      masterType: 'Question',
      multiSelectKey: 'rh-emp-19',
      optionList: 'ms',
      versionImported: '1.7.0',
      verificationTypeReq: 'base-verf',
      verificationSelectionOptList: 'verf-a-list',
      nonComOptionList: 'lf',
      nonCompliance: '',
      humanShowHide: '[2],ep-3--2,Yes',
      machineShowHide: '[2],ep-3--2,1',
      completionCondition: 'any ms',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [
    {
      id: 'ms',
      name: 'ms',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'rh-emp-23x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 34510,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
